import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-dialog-feature-draft',
  templateUrl: './dialog-feature-draft.component.html',
  styleUrls: ['./dialog-feature-draft.component.scss']
})
export class DialogFeatureDraftComponent implements OnInit {

  public draftCategoryList: string[] = ['undermaintenance', 'comingsoon'];
  public draftCategory: string;
  public draftMessage: string;
  public isSubmitted = false ;
  public theme: string = null;
  constructor(private dialogRef: MatDialogRef<DialogFeatureDraftComponent>, private adminService: AdminService) { }

  ngOnInit() {
    this.theme = environment.applicationName + '-' + this.adminService.selectedApplication;
    this.draftCategory = 'underMaintenance';
    this.draftMessage = 'We are sorry.\nThis Support Topic is currently under maintenance.\nPlease check back in a few hours.';
  }

  updateDraftMessage() {
    const defaultUnderMaintenance = 'We are sorry.\nThis Support Topic is currently under maintenance.\nPlease check back in a few hours.';
    const defaultComingSoon = 'This Support Topic is Coming Soon';
    this.draftMessage = this.draftCategory === 'comingSoon' ? defaultComingSoon : defaultUnderMaintenance;
  }

  save() {
    this.isSubmitted = true;
    const data = { draftCategory: this.draftCategory, draftMessage: this.draftMessage };
    if (this.draftMessage.trim() !== '') {
      this.dialogRef.close({ data });
    }
  }


}
